export default __webpack_public_path__ + "static/media/iconMenu_lamb.ba7e58a1.svg";